import { createAction } from '@reduxjs/toolkit';

export const clearOptionsAction = createAction('options/clearOptions');
